export default __webpack_public_path__ + "static/compareItemImg2-37e87c27cd6a087edff179fe3d25e9ad.webp";